import React, { useEffect, useState } from 'react';
import InfinityLoader from '../dropdownSearch/infinityLoader';
import API from '../../services/api';
import utils from '../../utils';

const SiteGroupSelector = ({ onSelect, filterObject, customFilter, selected, disabled, isAdmin = false }) => {
  const [currentItems, setCurrentItems] = useState([]);
  const [currentFilter, setCurrentFilter] = useState('');
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isOpen) {
      loadMoreItems();
    }
  }, [isOpen]);

  const handleApiResult = (filter, results) => {
    const fetchedData = results.projects.map(result => ({
      label: `${result.displayName} - ${result.id}`,
      value: `"${result.id}"`
    }));

    // Reset list when filter changes
    if (filter !== currentFilter) {
      setCurrentFilter(filter);
      setCurrentItems(fetchedData);
    } else {
      const newSiteGroup = utils.mergeArraysByField(fetchedData, currentItems, 'value');
      setCurrentItems(newSiteGroup);
    }

    return results.nextPageToken;
  };

  const loadMoreItems = (nextPageToken = '', searchingBy = '') => {
    const query = encodeURI(`displayName ILIKE "%${searchingBy}%" OR id ILIKE "%${searchingBy}%"`);
    let filter = searchingBy !== '' ? query : '';

    if (customFilter && filter === '') {
      const encodedCustomFilter = encodeURI(`${customFilter.field} = "${customFilter.value}"`);
      filter = encodedCustomFilter;
    } else if (customFilter && filter !== '') {
      const encodedCustomFilter = encodeURI(`${customFilter.field} = "${customFilter.value}"`);
      filter += ` AND ${encodedCustomFilter}`;
    }

    if (filter !== currentFilter) {
      setCurrentItems([]);
    }

    if (isAdmin) {
      return API.getSiteGroupsByCompany('-', 40, nextPageToken, filter).then(results => {
        return handleApiResult(filter, results);
      });
    }

    return API.getSiteGroups(40, nextPageToken, filter).then(results => {
      return handleApiResult(filter, results);
    });
  };

  return (
    <div className="sitegroup-selector">
      <InfinityLoader
        title={'Search Site Group'}
        leftAlign
        disabled={disabled}
        selected={selected}
        onSelect={selectedValue => onSelect(selectedValue, { ...filterObject, options: currentItems })}
        onLoading={loadMoreItems}
        onOpenChange={setIsOpen}
        totalSize={9999}
        options={currentItems}
      />
    </div>
  );
};

export default SiteGroupSelector;
